/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Styled components for LabelsImportStepFile
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.2
 * @since 1.3.0
 */

import { DropzoneRootProps } from 'react-dropzone';
import styled from 'styled-components';

import { icons } from '../../../../assets';
import { colors, fonts } from '../../../../theme';

interface ILabelsImportStepFileDropzoneStyled {
    isActive: boolean;
}

export const LabelsImportStepFileDropzoneStyled = styled.div.attrs((props: ILabelsImportStepFileDropzoneStyled) => ({
    className: props.isActive ? 'active' : '',
}))<ILabelsImportStepFileDropzoneStyled & DropzoneRootProps>`
    width: 100%;
    height: 110px;
    box-sizing: border-box;
    border: 1px dashed ${colors.borderColorLight};
    margin-bottom: 16px;
    ${fonts.textSmall};
    color: rgba(51, 51, 51, 0.5);
    text-align: center;
    padding: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    outline: none;

    span {
        margin-top: 8px;
        line-height: 16px;
    }

    &.active {
        border: 1px dashed rgba(51, 51, 51, 0.5);
        background: ${colors.backgroundColorModal};
    }
`;

export const LabelsImportFileContainerStyled = styled.div`
    width: 700px;
    margin-top: 32px;
    padding-bottom: 24px;
`;

export const LabelsImportFileHeaderStyled = styled.h4`
    margin: 0 0 20px 0;
    ${fonts.textMainBold};
`;

export const LabelsImportFileMessagesContainerStyled = styled.div`
    padding-top: 16px;
    margin-top: 32px;
    margin-bottom: 20px;
    border-top: 1px solid ${colors.borderColorDisabled};
    ${fonts.textSmall};

    & a {
        ${fonts.textLink};
        &:hover {
            border-bottom: 1px solid;
        }
    }
`;

export const LabelsImportAttachedFileContainerStyled = styled.div`
    display: flex;
    align-items: center;
    margin-top: 16px;
`;

export const LabelsImportAttachedFileNameStyled = styled.div`
    margin-left: 10px;
`;

export const LabelsImportAttachedFileCloseStyled = styled.div`
    width: 20px;
    height: 20px;
    margin-left: 10px;
    background: url(${icons.removeSmallOpacityIcon}) no-repeat;
    background-size: cover;
    cursor: pointer;

    &:hover {
        background: url(${icons.removeSmallIcon}) no-repeat;
    }
`;

export const LabelsImportFileErrorStyled = styled.div`
    color: ${colors.wizardHintValidationColorError};
    margin-top: 16px;
`;
